'use strict';

exports.__esModule = true;
exports.DataItems = undefined;

var _dataItem = require('./common/data-item');

var _dataItem2 = _interopRequireDefault(_dataItem);

var _biAppContextItem = require('./common/bi-app-context-item');

var _biAppContextItem2 = _interopRequireDefault(_biAppContextItem);

var _resourceItem = require('./resource/resource-item');

var _resourceItem2 = _interopRequireDefault(_resourceItem);

var _durationItem = require('./duration/duration-item');

var _durationItem2 = _interopRequireDefault(_durationItem);

var _utils = require('./phases/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItems = function () {
  function DataItems(sessionId, preset) {
    _classCallCheck(this, DataItems);

    this._sessionId = sessionId;
    this._preset = preset;
  }

  DataItems.prototype.biAppLoadStart = function biAppLoadStart() {
    return this._biDataItem(this._preset.appLoadStart.eventId);
  };

  DataItems.prototype.biAppLoadFinish = function biAppLoadFinish() {
    return this._biDataItem(this._preset.appLoadFinish.eventId);
  };

  DataItems.prototype.biInteractionStart = function biInteractionStart() {
    return this._biDataItem(this._preset.interactionStart.eventId);
  };

  DataItems.prototype.biInteractionEnd = function biInteractionEnd() {
    return this._biDataItem(this._preset.interactionEnd.eventId);
  };

  DataItems.prototype.biLoadPhaseStart = function biLoadPhaseStart() {
    return this._biDataItem(this._preset.loadPhaseStart.eventId);
  };

  DataItems.prototype.biLoadPhaseFinish = function biLoadPhaseFinish() {
    return this._biDataItem(this._preset.loadPhaseFinish.eventId);
  };

  DataItems.prototype.biError = function biError() {
    return this._biDataItem(this._preset.error.eventId);
  };

  DataItems.prototype.appName = function appName(_ref) {
    var _appName = _ref.appName,
        isServerSide = _ref.isServerSide;

    return this.dataItem({
      appName: isServerSide ? _appName + '_ssr' : _appName
    });
  };

  DataItems.prototype.artifact = function artifact(_ref2) {
    var artifactId = _ref2.id,
        artifactVersion = _ref2.version,
        isRollout = _ref2.isRollout;

    return this.dataItem({ artifactId: artifactId, artifactVersion: artifactVersion, isRollout: isRollout });
  };

  DataItems.prototype.appContext = function appContext(params) {
    return new _biAppContextItem2.default(params);
  };

  DataItems.prototype.customParams = function customParams(_customParams) {
    return this.dataItem({ customParams: _customParams });
  };

  DataItems.prototype.duration = function duration(_duration) {
    return new _durationItem2.default(_duration);
  };

  DataItems.prototype.loadingPhaseCollection = function loadingPhaseCollection(phasesOfApp) {
    var phases = JSON.stringify((0, _utils.createPhasesCollection)(phasesOfApp));
    return this.dataItem({ phases: phases });
  };

  DataItems.prototype.loadingPhaseStart = function loadingPhaseStart(_ref3) {
    var name = _ref3.name;

    return this.dataItem({ name: name });
  };

  DataItems.prototype.loadingPhaseFinish = function loadingPhaseFinish(_ref4) {
    var name = _ref4.name,
        phaseStartTime = _ref4.phaseStartTime;

    var duration = (0, _utils.calcPhaseDuration)(phaseStartTime);
    return this.dataItem({ name: name, duration: duration });
  };

  DataItems.prototype.loadingPhaseFinishPrefixed = function loadingPhaseFinishPrefixed(_ref5) {
    var name = _ref5.name,
        index = _ref5.index,
        phaseStartTime = _ref5.phaseStartTime;

    var prefixed = (0, _utils.loadingPhasePrefixed)(name, index);
    return this.loadingPhaseFinish({ name: prefixed, phaseStartTime: phaseStartTime });
  };

  DataItems.prototype.resource = function resource() {
    var data = this._asBiEvent(this._preset.resource.eventId);
    return new _resourceItem2.default(data);
  };

  DataItems.prototype.dataItem = function dataItem(params) {
    return new _dataItem2.default(params);
  };

  DataItems.prototype._biDataItem = function _biDataItem(eventId) {
    var data = this._asBiEvent(eventId);
    return this.dataItem(data);
  };

  DataItems.prototype._asBiEvent = function _asBiEvent(evid) {
    return {
      src: this._preset.src,
      evid: evid,
      session_id: this._sessionId,
      _: new Date().getTime() // cache buster
    };
  };

  return DataItems;
}();

exports.DataItems = DataItems;